var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "color-picker"
  }, [_c("a-popover", {
    attrs: {
      trigger: "click",
      overlayClassName: "color-popver",
      placement: "topLeft"
    }
  }, [_c("template", {
    slot: "content"
  }, [_c("sketch-picker", {
    attrs: {
      disableAlpha: true
    },
    on: {
      input: _vm.handleUpdate
    },
    model: {
      value: _vm.color,
      callback: function callback($$v) {
        _vm.color = $$v;
      },
      expression: "color"
    }
  })], 1), _c("div", {
    staticClass: "color",
    style: {
      "background-color": _vm.value
    }
  })], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };